import { Routes } from '@angular/router';
import { AppRoutesEnum } from '../../../@core/enum/appRoutes';


export const authLayoutRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('../../../modules/authentication/authentication-layout/authentication-layout.component').then((m) => m.AuthenticationLayoutComponent),
    children: [
      {
        path: AppRoutesEnum.LOGIN,
        loadComponent: () =>
          import('../../../modules/authentication/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: AppRoutesEnum.SIGNUP,
        loadComponent: () =>
          import('../../../modules/authentication/signup/signup.component').then((m) => m.SignupComponent),
      },
    ],
  },
];